import React, { useState, createContext, useContext } from "react";

interface AboutContextProps {
	scrollDisable: boolean;
	setScrollDisable: React.Dispatch<React.SetStateAction<boolean>>;
}
export const AboutContext = createContext({} as AboutContextProps);

const AboutProvider: React.FC = ({ children }) => {
	const [scrollDisable, setScrollDisable] = useState(false);

	return <AboutContext.Provider value={{ scrollDisable, setScrollDisable }}>{children}</AboutContext.Provider>;
};

export const useAboutScroll = () => {
	const { scrollDisable, setScrollDisable } = useContext(AboutContext);
	return { scrollDisable, setScrollDisable };
};

export default AboutProvider;
